.brand-slider-tile {
  text-decoration: none;
  max-width: 100%;
  width:100%;
}
